import { nameValueArrayFromObject } from './utils.js';
export const nameSuffixDisplay = {
    I: 'I',
    II: 'II',
    III: 'III',
    IV: 'IV',
    JR: 'Jr.',
    SR: 'Sr.',
    V: 'V',
};
export const nameSuffixes = nameValueArrayFromObject(nameSuffixDisplay);
//# sourceMappingURL=nameSuffixes.js.map